import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Transition } from '@headlessui/react';

const defaultProps = {
  isActive: false,
};

const propTypes = {
  isActive: PropTypes.bool,
  bgColor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function TestimonialSlideLogoWrapper({
  isActive,
  bgColor,
  children,
}) {
  return (
    <Transition
      show={isActive}
      enter="transition-opacity duration-700"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      appear={true}
    >
      <li
        className={clsx(
          'px-10 flex items-center justify-center absolute inset-0',
          bgColor
        )}
      >
        {children}
      </li>
    </Transition>
  );
}

TestimonialSlideLogoWrapper.defaultProps = defaultProps;
TestimonialSlideLogoWrapper.propTypes = propTypes;
